import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const cscProductGrid = {
  columnGap: css`var(--csc-product-grid-column-gap, var(--cs-spacing-08, ${csSpacing.spacing08}))`,
  rowGap: css`var(--csc-product-grid-row-gap, var(--cs-spacing-08, ${csSpacing.spacing08}))`,
  padding: css`var(--csc-product-grid-padding, ${csBorder.width})`,
  backgroundColor: css`var(--csc-product-grid-background-color, transparent)`,
}

export const style: CSSResult = css`
  /* Product Grid Styles - Matching the original product-grid component */
  .products-grid {
    display: grid;
    column-gap: ${cscProductGrid.columnGap};
    row-gap: ${cscProductGrid.rowGap};
    background-color: ${cscProductGrid.backgroundColor};
    padding: ${cscProductGrid.padding};
    position: relative;
  }

  @media (max-width: ${SCREENS.medium}) {
    csc-search-results-number,
    csc-display-modes {
      display: none;
    }
  }

  .products-grid.view-grid {
    grid-template-columns: repeat(var(--tiles-per-row-mobile, 1), 1fr);
    align-items: stretch; /* Force all items to same height */

    @media (min-width: ${SCREENS.medium}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media(min-width: ${SCREENS.extraLarge}) {
      grid-template-columns: repeat(var(--tiles-per-row, 3), 1fr);
    }
  }

  /* Force all tiles to be same height */
  .products-grid.view-grid > * {
    height: 100%;
  }

  .products-grid.view-grid csc-base-product-tile {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .products-grid.view-list {
    grid-template-columns: 1fr;
  }

  .loader-backdrop-inner {
    position: relative;
  }

  .loader-backdrop {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgb(255 255 255 / 40%);
  }

  cse-loader {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%);
  }

  .toolbar-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media(min-width: ${SCREENS.medium}) {
      justify-content: flex-start;
      column-gap: ${csSpacing.spacing06};
    }

    & > *:not(:first-child) {
      border-left: ${csSpacing.spacing00} solid ${csColorBorder.light};
      padding-left: ${csSpacing.spacing06};
    }
  }

  .product-count {
    --cs-font-body-s-font-weight: 700;
  }

  .results-number-selector,
  .display-modes-selector {
    display: none;

    @media(min-width: ${SCREENS.medium}) {
      display: block;
    }
  }
`
